<script setup lang="ts">
import { computed, ref } from 'vue'
import { storeToRefs } from 'pinia'
import { useDisplay } from 'vuetify'

import { useDrawerStore } from '@/stores/drawer'

import ProjectTitle from '@/components/project-detail/ProjectTitle.vue'

const { smAndDown } = useDisplay()

const drawerStore = useDrawerStore()
const { drawer } = storeToRefs(drawerStore)

const navigationItems = ref([
  {
    title: 'Project Overview',
    colTitle: '',
    icon: 'mdi-home',
    event: 'calculation-index'
  },
  {
    title: 'User Management',
    colTitle: '',
    icon: 'mdi-account-group',
    event: 'user-management'
  }
])

const drawerWidth = computed(() => (drawer.value.shown ? drawer.value.width : 60))

const drawerModel = computed({
  get: () => {
    return smAndDown.value ? drawer.value.shown : true
  },
  set: (val) => {
    drawer.value.shown = val
  }
})
</script>

<template>
  <v-navigation-drawer
    v-model="drawerModel"
    :mini-variant="!smAndDown && !drawer.shown"
    :width="drawerWidth"
    :permanent="!smAndDown"
  >
    <v-list class="py-0">
      <v-list-item-title v-if="drawer.shown && !smAndDown">
        <ProjectTitle />
      </v-list-item-title>
      <v-divider></v-divider>

      <v-list-item
        v-for="item in navigationItems"
        :key="item.event"
        :to="{ name: item.event, params: { id: $route.params.id } }"
        :active="$route.name === item.event"
        color="primary"
      >
        <div :class="drawer.shown ? 'd-flex align-center' : 'd-flex flex-column justify-center'">
          <v-icon :icon="item.icon" color="primary" :size="item.size ?? 'large'" />
          <div :class="drawer.shown ? 'px-3' : 'text-wrap text-center smaller-font'">
            {{ drawer.shown ? item.title : item.colTitle }}
          </div>
        </div>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>
